import { loggedIn } from '../../../routes/conditional';
import { addCCStoreItems,clearAddItemError,searchCCPharmacy,setDeliveryAddressOrderId } from '../../../redux/modules/orders';
import {getPendingOrdersDeliveryAddressOrderId} from '../../../redux/modules/root-reducer';

export const page = {
  path:  '/orders/:orderId/cc-select-pharmacy',
  isAllowed: [loggedIn],
  action: ({ state, params }) => setDeliveryAddressOrderId(params.orderId ?? getPendingOrdersDeliveryAddressOrderId(state)),
};


export const searchCCLocation = {
  actionPath: '/actions/search-cclocation',
  searchinputName: 'ccStoreName',
  cclocationInput: 'ccStoreID',
  action: ({ body }) => searchCCPharmacy(body?.ccStoreName),
};


export const addCCLocations = {
  actionPath: '/actions/add-ccstore-location',
  inputName: 'ccStoreDetails',
  mapccStoreInputValue: m => JSON.stringify(m),
  action: ({ body,state }) => addCCStoreItems(JSON.parse(body?.ccStoreDetails),getPendingOrdersDeliveryAddressOrderId(state)),
}

export const clearSelectionError = {
  actionPath: '/actions/clear-ccstore-location-error',
  action: () => clearAddItemError(),
};